import generalReducer from 'Store/Reducers/generalReducer';
import navbarReducer from 'Store/Reducers/navbarReducer';

export default {
  general: generalReducer,
  navbar: navbarReducer,
};
